module.exports = __webpack_public_path__ + "static/media/ss-memento.02854a19.png";